import groups from '../slices/groups';
import type { RootStateType, ThunkDispatchType } from '../index';
import {
    getGroups
} from '../../api/groups';
import { GroupForListType } from '../../types';
import { filterMarketEntities, groupToMarketFilters } from '../../utils/filter-market-entities';
import { pickLastByKey } from '../../utils';
import { getDefaultFulfilsProfile } from '../../utils/metadata';

export const {
    setActiveGroupTab
} = groups.actions;

/** Each group's count is what opening it in the market shows. */
function withMarketCounts(myGroups: GroupForListType[], state: RootStateType) {
    const { allOpenJobs, allOpenCapacities } = state.market;
    const fulfilsProfile = getDefaultFulfilsProfile(state.tenants.profile, state.metadata.metadataOrder);
    return myGroups.map((g: any) => {
        const entities = filterMarketEntities({
            entities: [...allOpenJobs, ...allOpenCapacities],
            filters: groupToMarketFilters(g.id, fulfilsProfile)
        });
        return ({
            ...g,
            publishedCount: entities.length,
            lastPublishedDate: pickLastByKey(entities, 'publishedAt')
        });
    });
}

/** Recounts after the market entities, the company profile or the metadata options changed. */
export function refreshMyGroupCounts() {
    return async (dispatch: ThunkDispatchType, getState: () => RootStateType) => {
        const state = getState();
        if (state.groups.my.length > 0) {
            dispatch(groups.actions.myFetched({ data: withMarketCounts(state.groups.my, state) }));
        }
    };
}

export function fetchAllGroups() {
    return async (dispatch: ThunkDispatchType, getState: () => RootStateType) => {
        try {
            dispatch(groups.actions.fetchMy());
            dispatch(groups.actions.fetchOther());

            const data = await getGroups();
            const myGroups: GroupForListType[] = [];
            const otherGroups: GroupForListType[] = [];
            data.forEach((g: GroupForListType) => {
                (g.isOwner || g.isAccepted ? myGroups : otherGroups).push(g);
            });

            dispatch(groups.actions.myFetched({ data: withMarketCounts(myGroups, getState()) }));
            dispatch(groups.actions.otherFetched({ data: otherGroups }));
        } catch (e) {
            console.log('ERROR fetching groups, set redux error state and handle in errorBoundary.', e);
            dispatch(groups.actions.myFetched({ data: [] }));
            dispatch(groups.actions.otherFetched({ data: [] }));
        }
    };
}

export const selectMyGroups = () => (state: RootStateType) => state.groups.my;
export const selectOtherGroups = () => (state: RootStateType) => state.groups.other;
export const selectFetchingMyGroups = () => (state: RootStateType) => state.groups.fetchingMy;
export const selectFetchingOtherGroups = () => (state: RootStateType) => state.groups.fetchingOther;
export const selectActiveGroupTab = () => (state: RootStateType) => state.groups.activeGroupTab;
